import { OptionsViewModel } from '@models/common.models';
export function compareOrder(a: OptionsViewModel, b: OptionsViewModel): 0 | 1 | -1 {
  if (a.order! < b.order!) {
    return -1;
  }
  if (a.order! > b.order!) {
    return 1;
  }
  return 0;
}



// WEBPACK FOOTER //
// ./src/common/comparators.ts